import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import PromotedContentStory from './promoted-story';

class Component extends BaseComponent {
    // necessary for desktop to handle 2 line headlines.
    // mobile doesn't care either way.
    rowLength = 2;

    componentWillMount() {
        this.props.requireState(this.props.limit);
    }

    render({ stories, title }) {
        if (!stories) {
            return (<promoted-content />);
        }

        return (
            <promoted-content class='container'>
                <header class='promoted_content_header'>
                    <h1 class='text-header-2'>
                        {title || 'The Latest'}
                        <span class='text-header-6'> FROM TAROT.COM</span>
                    </h1>
                </header>
                {stories.map(this.renderStory).reduce(this.groupRows, []).map(this.wrapRows)}
            </promoted-content>
        );
    }

    renderStory = (story, index) => (
        <PromotedContentStory story={story} index={index} img_size={this.props.img_size} />
    )

    groupRows = (rows, story) => {
        if (rows.length) {
            const lastRow = rows[rows.length - 1];
            if (lastRow.length < this.rowLength) {
                lastRow.push(story);
                return rows;
            }
        }
        rows.push([story]);
        return rows;
    }

    wrapRows = (row) => (
        <div class='row'>{ row }</div>
    )
}

const mapStateToProps = (state) => ({
    stories: state.content && state.content.promoted,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (limit) => dispatch({ type: 'content:fetchPromoted', payload: limit }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/content/promoted.js